import { PostsQueryQuery } from 'gql/graphql';

interface NewPostsState {
  posts: NonNullable<PostsQueryQuery['posts']>;
  markedNewPostIds: number[];
}

export const initialState: NewPostsState = {
  posts: [],
  markedNewPostIds: [],
};
